import { BallotState, __BallotState } from './ballot-state'
import { Outcome } from './outcome'

/**
 * Like BallotState, but the outcome can be explicitly overridden.
 */

export interface OverrideableBallotState {
  ballotState: BallotState
  outcome: undefined | Outcome
}

export const mkOverrideableBallotState = (x: OverrideableBallotState): OverrideableBallotState => x

export const __OverrideableBallotState = {
  pre: mkOverrideableBallotState({
    ballotState: __BallotState.pre,
    outcome: undefined,
  }),
  inProgress: mkOverrideableBallotState({
    ballotState: __BallotState.inProgress,
    outcome: undefined,
  }),
  trend: {
    yea: mkOverrideableBallotState({
      ballotState: __BallotState.trend.yea,
      outcome: undefined,
    }),
    nay: mkOverrideableBallotState({
      ballotState: __BallotState.trend.nay,
      outcome: undefined,
    }),
  },
  projection: {
    yea: mkOverrideableBallotState({
      ballotState: __BallotState.projection.yea,
      outcome: undefined,
    }),
    nay: mkOverrideableBallotState({
      ballotState: __BallotState.projection.nay,
      outcome: undefined,
    }),
  },
  finalResult: {
    yea: mkOverrideableBallotState({
      ballotState: __BallotState.finalResult.yea,
      outcome: undefined,
    }),
    yeaWithGap: mkOverrideableBallotState({
      ballotState: __BallotState.finalResult.yeaWithGap,
      outcome: undefined,
    }),
    nay: mkOverrideableBallotState({
      ballotState: __BallotState.finalResult.nay,
      outcome: undefined,
    }),
  },
  majorityOfCantonsReject: {
    pre: mkOverrideableBallotState({
      ballotState: __BallotState.pre,
      outcome: 'nay',
    }),
    yea: mkOverrideableBallotState({
      ballotState: __BallotState.projection.yea,
      outcome: 'nay',
    }),
    nay: mkOverrideableBallotState({
      ballotState: __BallotState.projection.nay,
      outcome: 'nay',
    }),
    finalResultNay: mkOverrideableBallotState({
      ballotState: __BallotState.finalResult.nay,
      outcome: 'nay',
    }),
  },
}
